<template>
  <div>
    <h6 class="title">{{ translate.result.hello }} {{ businessName }}</h6>

    <div v-if="type === 'manual'">
      {{ translate.result.manualReceived }} <br />
      {{ translate.result.manualInstruction }}

      <div class="manual-card-wrapper">
        <distributor-card
          v-for="(item, index) in resellers"
          :key="index"
          :info="item"
        />
      </div>
    </div>

    <div v-else>
      {{ translate.result.thanksInterest }}
      {{ translate.result.registrationReceived }}
      {{
        type === 'riffel'
          ? translate.result.riffelSoon
          : translate.result.distributorSoon
      }}
    </div>

    <br /><br />

    {{ translate.result.stayAlert }} <br />
    {{ translate.result.slogan }}
  </div>
</template>

<script>
import DistributorCard from './card/DistributorCard.vue';
export default {
  name: 'message-result',
  props: {
    businessName: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'riffel',
    }
  },
  components: {
    DistributorCard
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
    resellers() {
      return this.$store.getters.resellers;
    }
  },
};
</script>

<style lang="css" scoped>
.manual-card-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  margin-top: 15px;
}
</style>
